import {
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  HIDE_LOADING,
  INVITATION_SIGNUP,
  SHOW_AUTH_MESSAGE,
  SHOW_LOADING,
  SIGNIN,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SIGNUP,
  SIGNUP_SUCCESS,
  TOKENSIGNIN,
  UPDATE_AVATAR,
  UPDATE_CURRENT_PASSWORD,
  UPDATE_CURRENT_USER,
} from '../constants/Auth';

export const signIn = (credentials) => {
  return {
    type: SIGNIN,
    payload: credentials,
  };
};

export const tokenSignIn = ({ token, search_token, account, tutorial }) => {
  return {
    type: TOKENSIGNIN,
    token: token,
    account: account,
    tutorial: tutorial,
    searchToken: search_token,
  };
};

export const authenticated = ({ token, user, account, tutorial }) => {
  return {
    type: AUTHENTICATED,
    token,
    user,
    account,
    tutorial,
  };
};

export const updateCurrentUser = (data) => {
  return {
    type: UPDATE_CURRENT_USER,
    user: data,
  };
};

export const updateCurrentPassword = (payload) => {
  return {
    type: UPDATE_CURRENT_PASSWORD,
    payload: payload,
  };
};

export const updateAvatar = (avatar) => {
  return {
    type: UPDATE_AVATAR,
    avatar: avatar,
  };
};

export const signOut = (history) => {
  return {
    type: SIGNOUT,
    history,
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user,
  };
};

export const invitationSignUp = (user) => {
  return {
    type: INVITATION_SIGNUP,
    payload: user,
  };
};

export const signUpSuccess = ({ token, user, account, tutorial }) => {
  return {
    type: SIGNUP_SUCCESS,
    token,
    user,
    account,
    tutorial,
  };
};

export const signInWithGoogle = () => {
  return {
    type: SIGNIN_WITH_GOOGLE,
  };
};

export const signInWithGoogleAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token,
  };
};

export const signInWithFacebook = () => {
  return {
    type: SIGNIN_WITH_FACEBOOK,
  };
};

export const signInWithFacebookAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};
